<template>
  <div>
    <button type="button"
            class="btn btn-default bct-back"
            @click="$emit('back')"><i class="fal fa-arrow-left mr-1"></i>{{ $t("broadcast.screens.library.back") }}</button>
    <h4 class="bct-q">{{ $t("broadcast.screens.library.title") }}</h4>
    <div v-if="loading"
         class="bct-load"><i class="fal fa-spinner-third fa-spin"></i></div>
    <p v-else-if="error"
       class="bct-note">{{ error }}</p>
    <div v-else
         class="bct-list">
      <div v-for="t in templates"
           :key="t.key || 'own-' + t.id"
           class="bct-card">
        <div class="bct-head"><b>{{ titleOf(t) }}</b></div>
        <p class="bct-origin">{{ $t(t.owner === "proship" ? "broadcast.screens.library.origin_std" : "broadcast.screens.library.origin_own") }}</p>
        <p v-if="status(t).kind"
           :class="'bct-' + status(t).kind">{{ status(t).text }}</p>
        <BcBubble :parts="partsOf(t)" />
        <p v-if="status(t).reject"
           class="bct-rejected">{{ status(t).reject }}</p>
        <div class="bct-actions">
          <button type="button"
                  class="btn btn-outline-primary"
                  @click="$emit('use', { itype: itypeOf(t), template: t })">{{ $t("broadcast.screens.library.use") }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BcBubble from "@/components/derived/broadcast/BcBubble";
import { ITYPES } from "@/components/derived/broadcast/copy";

const TOKEN = /\{\{([a-z][a-z0-9_]*)\}\}/g;

// ข้อความที่บันทึกไว้: the three ProShip messages and the seller's own, each with เฟส's answer per Page.
// Emits back and use({itype, template}): the parent opens the popup at step 4.
export default {
  name: "BcTemplates",
  components: { BcBubble },
  data() {
    return { templates: [], loading: true, error: "" };
  },
  created() {
    this.$store.dispatch("broadcast/fetchTemplates", {
      callback: (ok, data) => {
        this.loading = false;
        if (ok) this.templates = data.templates || [];
        else this.error = data.messageTh || "";
      },
    });
  },
  methods: {
    titleOf(t) {
      return t.owner === "proship" ? t.typeTh : this.$t("broadcast.screens.itype.own");
    },
    itypeOf(t) {
      const def = ITYPES.find((x) => x.templateKey && x.templateKey === t.key);
      return def ? def.key : "own";
    },
    // The body with each {{key}} shown as its label: ours grey, the seller's blue
    partsOf(t) {
      const body = String(t.body || "");
      const out = [];
      let last = 0;
      let m;
      TOKEN.lastIndex = 0;
      while ((m = TOKEN.exec(body))) {
        if (m.index > last) out.push({ t: body.slice(last, m.index), kind: "" });
        const slot = (t.slots || []).find((s) => s.key === m[1]);
        out.push({ t: "{{" + ((slot && slot.labelTh) || m[1]) + "}}", kind: slot && slot.filledBy === "us" ? "name" : "slot" });
        last = m.index + m[0].length;
      }
      if (last < body.length) out.push({ t: body.slice(last), kind: "" });
      return out;
    },
    // เฟส's answer over the Pages the message is registered on
    status(t) {
      const pages = t.pages || [];
      const approved = pages.filter((p) => p.status === "approved").length;
      const rejected = pages.filter((p) => p.status === "rejected");
      const pending = pages.length - approved - rejected.length;
      const reject = rejected.length && rejected.length === pages.length ? rejected[0].rejectTh || "" : "";
      if (pages.length && approved === pages.length) return { kind: "approved", text: this.$t("broadcast.screens.library.approved"), reject };
      if (rejected.length === pages.length && pages.length) return { kind: "", text: "", reject };
      if (approved === 0) return { kind: "pending", text: this.$t("broadcast.screens.library.pending"), reject };
      return {
        kind: "pending",
        text: this.$t("broadcast.screens.library.approved_n", { n: approved.toLocaleString("en-US"), m: (pending + rejected.length).toLocaleString("en-US") }),
        reject,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.bct-back {
  margin-bottom: 0.75rem;
  min-height: 44px;
}

.bct-q {
  font-size: 1.5556rem;
  font-weight: 300;
  color: #333;
  margin: 0 0 1rem;
}

.bct-load,
.bct-note {
  text-align: center;
  color: #666;
  padding: 1.5rem 0;
}

.bct-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.bct-card {
  border: 2px solid #e3e3e3;
  border-radius: 10px;
  padding: 1rem;
  background: #fff;
}

.bct-head b {
  color: #333;
  font-size: 1.05rem;
}

.bct-origin {
  color: #666;
  font-size: 0.875rem;
  margin: 0.2rem 0 0;
}

.bct-approved {
  color: #1a6e2e;
  font-weight: 700;
  font-size: 0.875rem;
  margin: 0.35rem 0 0.6rem;
}

.bct-pending {
  color: #9a5a00;
  font-weight: 700;
  font-size: 0.875rem;
  margin: 0.35rem 0 0.6rem;
}

.bct-rejected {
  color: #c62828;
  font-weight: 700;
  font-size: 0.875rem;
  margin: 0.6rem 0 0;
}

.bct-card .bc-bubble,
.bct-card ::v-deep .bc-bubble {
  margin-top: 0.5rem;
}

.bct-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-top: 0.75rem;

  .btn {
    min-height: 44px;
  }
}

body.--dark {
  .bct-q,
  .bct-head b {
    color: #e6e6e6;
  }

  .bct-origin,
  .bct-load,
  .bct-note {
    color: #c4c4c4;
  }

  .bct-card {
    background: #4b4b4b;
    border-color: #555;
  }

  .bct-approved {
    color: #8fe3a0;
  }

  .bct-pending {
    color: #ffd98a;
  }

  .bct-rejected {
    color: #ff9d9d;
  }
}
</style>

